var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RequestClient } from "../basics/request-client.service";
import { autoinject, computedFrom } from "aurelia-framework";
import * as TokenConstants from '../../constants/authentication/token.constants';
import * as Enumerable from "linq";
import getSymbolFromCurrency from 'currency-symbol-map';
import { UserClaimsService } from "./user-claims.service";
import { SignalClientService, SignalFunctions } from "../basics/signal-client.service";
import { BaseReconnect } from '../modules/base-reconnect';
import { CurrencyClientService } from '../modules/currency-client.service';
import { CacheClient, CacheKeys } from '../basics/client-caching.service';
import { ConfigurationService } from '../basics/configuration.service';
import { RequestConstants } from '../../configuration/request.constants';
import { UserClientService } from './user-client.service';
import { LotteryPlatformClaims } from '../../constants/modules/lotteryplatform.claims';
var TokenClient = /** @class */ (function (_super) {
    __extends(TokenClient, _super);
    function TokenClient(requestClient, signalService, cacheClient, userClientService, userClaimsService, currencyClientService, configurationService) {
        var _this = _super.call(this, signalService) || this;
        _this.requestClient = requestClient;
        _this.cacheClient = cacheClient;
        _this.userClientService = userClientService;
        _this.userClaimsService = userClaimsService;
        _this.currencyClientService = currencyClientService;
        _this.configurationService = configurationService;
        _this._defaultCurrencySymbol = "€";
        _this._defaultCurrencyCode = "EUR";
        _this._defaultCurrencyName = "Euro";
        _this.currencies = [];
        _this.onPlayerBalanceFunc = _this.onPlayerBalance.bind(_this);
        signalService.subscribe(SignalFunctions.onPlayerBalance, _this.onPlayerBalanceFunc);
        _this.attached();
        return _this;
    }
    TokenClient.prototype.activate = function () {
    };
    Object.defineProperty(TokenClient.prototype, "externalTermsAndCondition", {
        get: function () {
            return this.externalTermsAndConditionsConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenClient.prototype, "termsAndConditions", {
        get: function () {
            return this.termsAndConditionConfig;
        },
        enumerable: false,
        configurable: true
    });
    TokenClient.prototype.defaultCurrencyName = function () {
        return this._defaultCurrencyName;
    };
    TokenClient.prototype.getLotteries = function () {
        return this.lotteries.values;
    };
    TokenClient.prototype.onReconnected = function () {
        this.getBalance();
    };
    TokenClient.prototype.isBrandAdmin = function () {
        return this.user && this.user.userBrands && this.user.userBrands.length > 0;
    };
    TokenClient.prototype.isOperatorAdmin = function () {
        return this.user && this.user.userOperators && this.user.userOperators.length > 0;
    };
    TokenClient.prototype.isSuperAdmin = function () {
        return this.user && this.user.isAdmin && Enumerable.from(this.user.claims).any(function (x) { return x.permission == LotteryPlatformClaims.PlatformAdmin; });
    };
    TokenClient.prototype.onPlayerBalance = function (balance) {
        this.user.balance = balance.balance;
    };
    TokenClient.prototype.register = function (tokenRequest) {
        return this.requestClient.post(TokenConstants.Urls.Register, {}, tokenRequest);
    };
    TokenClient.prototype.login = function (tokenRequest) {
        return this.requestClient.post(TokenConstants.Urls.Login, {}, tokenRequest);
    };
    TokenClient.prototype.logout = function () {
        return this.requestClient.post(TokenConstants.Urls.Logout, {}, {});
    };
    TokenClient.prototype.getBalance = function () {
        var _this = this;
        if (this.isAuthenticated) {
            this.requestClient.get(TokenConstants.Urls.GetBalance, { bonusGameId: this.gameId }).then(function (x) {
                if (_this.user)
                    _this.user.balance = x;
            }, function (x) {
            });
        }
    };
    TokenClient.prototype.setUser = function (user) {
        this.user = user;
        this.userClientService.currentUser = {
            accessibleDepartmentIds: [],
            allowedClaims: user.claims,
            branchId: user.branchId,
            branchName: user.brandName,
            departmentId: user.departmentId,
            email: user.email,
            departmentName: null,
            id: user.userId,
            roleId: user.roleId,
            roleName: user.roleName,
            isManager: user.isAdmin,
            userName: user.userName,
            roles: [],
            enableMultilingualTermsAndConditions: user.enableMultilingualTermsAndConditions
        };
        this.setAuthCache(user);
        this.isAuthenticated = user.isAuthenticated;
        var playerId = this.user.playerId ? this.user.playerId : "anonymous";
        window.dataLayer.push({
            'event': "session_started",
            'brandId': this.user.brandId,
            'playerId': playerId,
            'brandName': this.user.brandName,
            // "countryId":this.getCountryId()
        });
    };
    TokenClient.prototype.setAuthCache = function (user) {
        this.cacheClient.put(CacheKeys.userId, user.userId);
        this.cacheClient.put(CacheKeys.roleId, user.roleId);
        this.configurationService.add({
            key: "UserId",
            value: user.userId,
            type: RequestConstants.ConfigurationTypes.RequestHeaders
        });
        this.configurationService.add({
            key: "RoleId",
            value: user.roleId,
            type: RequestConstants.ConfigurationTypes.RequestHeaders
        });
    };
    TokenClient.prototype.getCurrencySymbol = function () {
        return this.user && this.user.currencyCode ? getSymbolFromCurrency(this.user.currencyCode) : this._defaultCurrencySymbol;
    };
    TokenClient.prototype.reloadUser = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestClient.post(TokenConstants.Urls.ReloadUser, {}, {}).then(function (x) {
                _this.user = x;
                _this.userClientService.currentUser = x;
                _this.setAuthCache(_this.user);
                _this.userClaimsService.setUserClaims(_this.user.claims);
                resolve();
            }, reject);
        });
    };
    TokenClient.prototype.getUserCurrency = function () {
        var userCurrencyCode = this.getCurrencyCode();
        var currenciesEnumerable = Enumerable.from(this.currencies);
        var currency = currenciesEnumerable.firstOrDefault(function (x) { return x.currencyCode == userCurrencyCode; });
        return currency;
    };
    TokenClient.prototype.getCountryId = function () {
        return this.user ? this.user.countryId : null;
    };
    TokenClient.prototype.getCurrencyCode = function () {
        return this.user && this.user.currencyCode ? this.user.currencyCode : this._defaultCurrencyCode;
    };
    TokenClient.prototype.isAdmin = function () {
        return this.user && this.user.isAuthenticated && this.user.isAdmin;
    };
    TokenClient.prototype.isClient = function () {
        return (this.user && this.user.isAuthenticated && !this.isAdmin()) || this.user.loggedInFromBrandUrl;
    };
    TokenClient.prototype.isAgent = function () {
        return this.isClient() && this.user && this.user.isAgent;
    };
    TokenClient.prototype.setStorageUri = function (azureStorageUri) {
        this.storageUri = azureStorageUri;
    };
    TokenClient.prototype.setIsDevelopment = function (isDevelopment, hostName) {
        this.isDevelopment = isDevelopment;
        this.hostName = hostName;
    };
    TokenClient.prototype.changePassword = function (request) {
        return this.requestClient.post(TokenConstants.Urls.ChangePassword, {}, request);
    };
    __decorate([
        computedFrom("externalTermsAndConditionsConfig"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], TokenClient.prototype, "externalTermsAndCondition", null);
    __decorate([
        computedFrom("termsAndConditionConfig"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], TokenClient.prototype, "termsAndConditions", null);
    TokenClient = __decorate([
        autoinject,
        __metadata("design:paramtypes", [RequestClient, SignalClientService, CacheClient,
            UserClientService,
            UserClaimsService, CurrencyClientService, ConfigurationService])
    ], TokenClient);
    return TokenClient;
}(BaseReconnect));
export { TokenClient };
